
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../../../framework/state';
import { getResource, putResource } from '../../../../../framework/client/resource';
import { getDatabaseOptions, getEnumerationOptions } from '../../../../../framework/service/options';

import TextField from '../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../framework/fields/SelectField.vue';
import SwitchField from '../../../../../framework/fields/SwitchField.vue';
import IntegerField from '../../../../../framework/fields/IntegerField.vue';

import { PurchaseInvoiceRowMapping } from '../../../../../../common/application/model/PurchaseInvoiceRowMapping';
import { InvoiceRowType } from '../../../../../../common/application/model/enums/InvoiceRowType';
import { VendorContractType } from '../../../../../../common/application/model/enums/VendorContractType';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';
import { VendorType } from '../../../../../../common/application/model/enums/VendorType';
import { InvoicePeriodizationType } from '../../../../../../common/application/model/enums/InvoicePeriodizationType';

import { getVendorOptions } from '../../../../service/application_options_service';
import { errorToast, successToast } from "../../../../service/toast_service";

@Component({
    components: {
        IntegerField,
        SwitchField,
        SelectField,
        TextField,
        ValidationObserver,
    },
})
export default class EditPurchaseInvoiceRowMapping extends Vue {
    readonly resourceType = ApplicationResource.PURCHASE_INVOICE_ROW_MAPPING;

    @Prop(String) readonly id!: string;

    shared = sharedState;
    local = {
        row: {} as PurchaseInvoiceRowMapping,
        vendorTypeOptions: [] as { id: string | undefined; label: string }[],
        vendorOptions: [] as { id: string | undefined; label: string }[],
        invoiceRowTypeOptions: [] as { id: string | undefined; label: string }[],
        vendorContractTypeOptions: [] as { id: string | undefined; label: string }[],
        invoicePeriodizationTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    async mounted() {
        this.local.vendorTypeOptions = getEnumerationOptions('VendorType', Object.keys(VendorType), this);
        this.local.vendorOptions = await getVendorOptions();
        this.local.row = (await getResource<PurchaseInvoiceRowMapping>(this.resourceType, this.id))!!;
        this.local.invoiceRowTypeOptions = await getDatabaseOptions('InvoiceRowType', this);
        this.local.vendorContractTypeOptions = getEnumerationOptions(
            'VendorContractType',
            Object.keys(VendorContractType),
            this,
        );

        this.local.invoicePeriodizationTypeOptions = getEnumerationOptions(
            'InvoicePeriodizationType',
            Object.keys(InvoicePeriodizationType),
            this,
        );
    }

    async save() {
        await this.saveResource();
    }

    async saveAndClose() {
        await this.saveResource(true);
    }

    async saveResource(goBack?: boolean): Promise<void> {
        try {
            await putResource(this.resourceType, this.id, this.local.row);
            successToast(this, 'message.purchaseInvoiceMappingSaved');

            if (goBack) {
                this.back();
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
